import { exWeaponTokenProperty } from "../../property/resource/ex-weapon-token-property";
import { ResourceColumn } from "../planner-column";

export const exWeaponTokenColumn = new ResourceColumn(
  'EX Weapon Tokens',
  'stl_item_usable_0049.g1t.png',
  'exWeaponTokens',
  exWeaponTokenProperty,
)
